import { ADD_COMMENT, FETCH_COMMENTS, FETCH_ALL_COMMENTS } from "../actions";

export default function(state = {}, action) {
    switch (action.type) {
        case FETCH_ALL_COMMENTS:
            return action.payload;
        case FETCH_COMMENTS:
            return action.payload;
        case ADD_COMMENT:
            return [ ...state, action.payload ];
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/comments_reducer.js